import { render } from "./B2bTableServicios.vue?vue&type=template&id=647414a0&scoped=true&lang=pug"
import script from "./B2bTableServicios.vue?vue&type=script&lang=js"
export * from "./B2bTableServicios.vue?vue&type=script&lang=js"

import "./B2bTableServicios.vue?vue&type=style&index=0&id=647414a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647414a0"]])

export default __exports__